module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/F0018572_banner_web.59dd2b4c.png";